<template>
  <div>
    <v-card color="#EDF1F3">
      <v-layout align-center justify-start style="padding-inline-start: 20px">
        <loading-component :value="loading" />
        <v-form ref="form">
          <img :src="api.GET_IMAGE(passenger.profile_image)" class="image" v-if="passenger" />
        </v-form>

        <v-flex xs3>
          <div class="headline">
            {{ this.passenger.full_name }}
          </div>
          <div style="color: #8599a3">{{ this.passenger.email }}</div>
          <div v-if="passenger.type == 'NORMAL'" style="color: #8599a3; margin-top: 6px">
            {{ moment(this.passenger.birthday).format("DD MMM YYYY") }}
          </div>
        </v-flex>

        <v-flex xs2>
          <v-switch v-if="passenger.approved_at" v-model="disabledSwitch"
            :label='disabledSwitch ? $t("passengersPage.unblock") : $t("passengersPage.block")'
            @change="changeDisabledStatus" color="red"></v-switch>
        </v-flex>
        <v-flex xs2>
          <div>
            <v-btn v-if="!passenger.approved_at" @click="register" :loading="registerLoading" style="float: inline-end"
              color="primary">{{ $t("passengersPage.accept") }}</v-btn>
          </div>
        </v-flex>
      </v-layout>
    </v-card>

    <v-tabs v-model="active" color="#FAFAFA" slider-color="primary" fixed-tabs>
      <v-tab :key="1" ripple active-class="tab"> {{ $t("passengersPage.passengerTab") }} </v-tab>

      <v-tab-item>
        <div @touchstart.stop @touchmove.stop class="tab-content-wrapper">
          <v-card height="100%" style="height: 100%; position: absolute; width: 100%">
          <v-layout align-center>
            <v-flex xs6 style="height: 100%; margin-inline-start: 100px">
              <v-card-title primary-title>
                <v-flex xs12 style="margin-bottom: 25px">
                  <div class="headline">{{ $t("passengersPage.information") }}</div>
                </v-flex>
                <table>
                  <tr>
                    <th>{{ $t("passengersPage.id") }}</th>
                    <td>
                      <span>{{ this.passenger.id }}</span>
                    </td>
                  </tr>
                  <tr>
                    <th>{{ $t("passengersPage.fullName") }}</th>
                    <td>
                      <v-text-field v-model="editHolder.full_name_value" style="float: inline-start"
                        :label='$t("passengersPage.fullName")' :disabled="!this.editHolder.full_name"
                        :rules="[(val) => !!val || $t('passengersPage.required')]">
                      </v-text-field>
                      <button @click="editHolder.full_name = true" v-if="!this.editHolder.full_name">
                        <v-icon>edit</v-icon>
                      </button>
                      <button @click="
                        editHolder.full_name = false;
                      editHolder.full_name_value = passenger.full_name;
                      " v-if="this.editHolder.full_name">
                        <v-icon>close</v-icon>
                      </button>
                      <button @click="editHolder.full_name = false" v-if="this.editHolder.full_name">
                        <v-icon>check</v-icon>
                      </button>
                    </td>
                  </tr>
                  <tr v-if="passenger.type == 'HOTEL'">
                    <th>{{ $t("passengersPage.businessName") }}</th>
                    <td>
                      <span>{{ this.passenger.hotel_name }}</span>
                    </td>
                  </tr>
                  <!-- QA 26-8 §3.1: phone/gender/birthday/email are editable now,
                       same per-field pencil pattern as full_name / CaptainProfile.
                       Every save is audit-logged backend-side (who + when). -->
                  <tr>
                    <th>{{ $t("passengersPage.phoneNumber") }}</th>
                    <td>
                      <v-text-field v-model="editHolder.phone_number_value" style="float: inline-start"
                        :label='$t("passengersPage.phoneNumber")' :disabled="!this.editHolder.phone_number"
                        :rules="[(val) => !!val || $t('passengersPage.required')]">
                      </v-text-field>
                      <button @click="editHolder.phone_number = true" v-if="!this.editHolder.phone_number">
                        <v-icon>edit</v-icon>
                      </button>
                      <button @click="
                        editHolder.phone_number = false;
                      editHolder.phone_number_value = passenger.phone_number;
                      " v-if="this.editHolder.phone_number">
                        <v-icon>close</v-icon>
                      </button>
                      <button @click="editHolder.phone_number = false" v-if="this.editHolder.phone_number">
                        <v-icon>check</v-icon>
                      </button>
                    </td>
                  </tr>
                  <tr v-if="passenger.type == 'NORMAL'">
                    <th>{{ $t("passengersPage.gender") }}</th>
                    <td>
                      <v-select v-model="editHolder.gender_value" :items="genderItems" style="float: inline-start"
                        :label='$t("passengersPage.gender")' :disabled="!this.editHolder.gender">
                      </v-select>
                      <button @click="editHolder.gender = true" v-if="!this.editHolder.gender">
                        <v-icon>edit</v-icon>
                      </button>
                      <button @click="
                        editHolder.gender = false;
                      editHolder.gender_value = normalizedGender(passenger.gender);
                      " v-if="this.editHolder.gender">
                        <v-icon>close</v-icon>
                      </button>
                      <button @click="editHolder.gender = false" v-if="this.editHolder.gender">
                        <v-icon>check</v-icon>
                      </button>
                    </td>
                  </tr>
                  <tr v-if="passenger.type == 'NORMAL'">
                    <th>{{ $t("passengersPage.dateOfBirth") }}</th>
                    <td>
                      <v-text-field v-model="editHolder.birthday_value" type="date" :max="today"
                        style="float: inline-start" :label='$t("passengersPage.dateOfBirth")'
                        :disabled="!this.editHolder.birthday">
                      </v-text-field>
                      <button @click="editHolder.birthday = true" v-if="!this.editHolder.birthday">
                        <v-icon>edit</v-icon>
                      </button>
                      <button @click="
                        editHolder.birthday = false;
                      editHolder.birthday_value = initialBirthday();
                      " v-if="this.editHolder.birthday">
                        <v-icon>close</v-icon>
                      </button>
                      <button @click="editHolder.birthday = false" v-if="this.editHolder.birthday">
                        <v-icon>check</v-icon>
                      </button>
                    </td>
                  </tr>
                  <tr>
                    <th>{{ $t("passengersPage.email") }}</th>
                    <td>
                      <v-text-field v-model="editHolder.email_value" style="float: inline-start"
                        :label='$t("passengersPage.email")' :disabled="!this.editHolder.email">
                      </v-text-field>
                      <button @click="editHolder.email = true" v-if="!this.editHolder.email">
                        <v-icon>edit</v-icon>
                      </button>
                      <button @click="
                        editHolder.email = false;
                      editHolder.email_value = passenger.email;
                      " v-if="this.editHolder.email">
                        <v-icon>close</v-icon>
                      </button>
                      <button @click="editHolder.email = false" v-if="this.editHolder.email">
                        <v-icon>check</v-icon>
                      </button>
                    </td>
                  </tr>
                  <tr>
                    <th>{{ $t("passengersPage.accountStatus") }}</th>
                    <td>
                      <!-- Owner item 3.1: active / inactive / banned (a banned
                           rider used to read "inactive" here). -->
                      <span :style="{ color: accountStateColor, fontWeight: 600 }">{{ accountStateLabel }}</span>
                      <div v-if="passenger && passenger.blacklisted_at && passenger.blacklist_note" class="ban-note">
                        {{ $t("accountState.noteLabel") }}: {{ passenger.blacklist_note }}
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th>{{ $t("passengersPage.accountType") }}</th>
                    <td>
                      <span>
                        {{
                          passenger.type == "HOTEL"
                            ? $t("passengersPage.hotel")
                            : $t("passengersPage.normal")
                        }}
                      </span>
                    </td>
                  </tr>
                  <tr v-if="passenger.public_rider_code">
                    <th>{{ $t("passengersPage.riderCode") }}</th>
                    <td>
                      <span style="letter-spacing: 1px; font-weight: 600">{{ passenger.public_rider_code }}</span>
                    </td>
                  </tr>
                  <tr>
                    <th>{{ $t("passengersPage.creationDate") }}</th>
                    <td>
                      <span>
                        {{
                          $companyTime(
                            passenger.created_at,
                            "DD-MM-YYYY HH:mm"
                          )
                        }}
                      </span>
                    </td>
                  </tr>
                </table>
              </v-card-title>
            </v-flex>
          </v-layout>
          <v-btn @click="save" :loading="loading" style="float: inline-end" color="primary"
            :disabled="disableSaveButton">{{ $t("passengersPage.save") }}</v-btn>
        </v-card>
        </div>
      </v-tab-item>

      <v-tab active-class="tab" :key="2" ripple> {{ $t("passengersPage.tripsTab") }} </v-tab>

      <v-tab-item>
        <div @touchstart.stop @touchmove.stop class="tab-content-wrapper">
          <DataTable :url="`passenger/${$route.params.id}/bookings`" :sortable="true" :enable-edit="false"
            :enable-add="false" :enable-delete="false" :formatter="formatters" :actions-extra-main="actionsExtraMain"
            :fields-hidden-main="[]" :titles="tripsTitles" />
        </div>
      </v-tab-item>
    </v-tabs>
  </div>
</template>

<script>
import LoadingComponent from "@/components/LoadingComponent";
import StatusToggle from "@/components/monaco/input/StatusToggle";
import DataTable from "@/components/monaco/DataTable";
import moment from "moment";
import { companyNow, formatCompanyTime } from "@/util/companyTime";
import { ACCOUNT_STATE_COLORS, BAN_NOTE_MAX, isAccountState } from "@/constants/accountState";

export default {
  name: "PassengerProfile",
  title: "passengersPage.profileTitle",
  components: {
    LoadingComponent,
    StatusToggle,
    DataTable,
  },

  data() {
    return {
      registerLoading: false,
      passenger: null,
      loading: true,
      dialog: false,
      active: 0,
      disabledSwitch: false,
      // QA 26-8 §3.1: one flag+value pair per editable field (the dead
      // username holder — no rendered input, save-blocking empty guard — was
      // removed while extending this).
      editHolder: {
        full_name: false,
        full_name_value: "",
        phone_number: false,
        phone_number_value: "",
        email: false,
        email_value: "",
        gender: false,
        gender_value: null,
        birthday: false,
        birthday_value: "",
      },
    };
  },
  mounted() {
    this.axios.get(`passenger/${this.$route.params.id}`).then(({ data }) => {
      this.passenger = data.data;
      this.seedEditHolder();
      this.disabledSwitch = !!this.passenger.blacklisted_at;
      this.loading = false;
    });
  },
  methods: {
    openImage(value) {
      // console.log(value);
      window.open(this.api.GET_IMAGE(value.path), "_blank");
    },
    // QA 26-8 §3.1: seed every editable value from the freshly loaded (or
    // freshly saved) passenger so cancel/diff logic compares against reality.
    seedEditHolder() {
      this.editHolder.full_name_value = this.passenger.full_name;
      this.editHolder.phone_number_value = this.passenger.phone_number;
      this.editHolder.email_value = this.passenger.email;
      this.editHolder.gender_value = this.normalizedGender(this.passenger.gender);
      this.editHolder.birthday_value = this.initialBirthday();
    },
    normalizedGender(value) {
      if (value === null || value === undefined || value === "") return null;
      // Backend boolean: 1/true = Male, 0/false = Female.
      return value === true || String(value) === "1" ? 1 : 0;
    },
    initialBirthday() {
      return this.passenger && this.passenger.birthday
        ? moment(this.passenger.birthday).format("YYYY-MM-DD")
        : "";
    },
    changedFields() {
      const updatedInfo = {};
      if (!this.passenger) return updatedInfo;
      if (
        this.editHolder.full_name_value &&
        this.editHolder.full_name_value != this.passenger.full_name
      )
        updatedInfo["full_name"] = this.editHolder.full_name_value;

      if (
        this.editHolder.phone_number_value &&
        this.editHolder.phone_number_value != this.passenger.phone_number
      )
        updatedInfo["phone_number"] = this.editHolder.phone_number_value;

      if ((this.editHolder.email_value || "") != (this.passenger.email || ""))
        updatedInfo["email"] = this.editHolder.email_value || null;

      if (
        this.editHolder.gender_value !== null &&
        this.editHolder.gender_value !== this.normalizedGender(this.passenger.gender)
      )
        updatedInfo["gender"] = this.editHolder.gender_value;

      if ((this.editHolder.birthday_value || "") != this.initialBirthday())
        updatedInfo["birthday"] = this.editHolder.birthday_value || null;

      return updatedInfo;
    },
    save() {
      // Name and phone must never be blanked; other fields may be cleared.
      if (
        this.editHolder.full_name_value == "" ||
        this.editHolder.phone_number_value == ""
      )
        return;

      const updatedInfo = this.changedFields();
      if (Object.keys(updatedInfo).length === 0) return;

      this.axios
        .put(`passenger/${this.$route.params.id}`, updatedInfo)
        .then(({ data }) => {
          // Server response is the source of truth (audited write).
          this.passenger = { ...this.passenger, ...data.data };
          this.seedEditHolder();
          window.getApp.$emit("SHOW_TOAST", this.$t("passengersPage.saved"), "green");
        })
        .catch((err) => {
          // Surface the first validation message (e.g. duplicate phone).
          const res = err.response && err.response.data;
          let message = res && res.message;
          if (res && res.errors) {
            const first = Object.values(res.errors)[0];
            if (first && first.length) message = first[0];
          }
          window.getApp.$emit("SHOW_TOAST", message, "red", [
            "bottom",
            "left",
          ]);
        });
    },
    changeDisabledStatus(val) {
      const disabled = val ? 1 : 0;

      const title = val
        ? this.$t("passengersPage.blockAccount")
        : this.$t("passengersPage.unblockAccount");
      const paragraph = val
        ? this.$t("passengersPage.blockConfirm")
        : this.$t("passengersPage.unblockConfirm");

      this.$dialova({
        title,
        paragraph,
        // Owner item 3.1: an optional ban note, stored in blacklist_note.
        input: val ? this.$t("accountState.notePlaceholder") : null,
        maxlength: BAN_NOTE_MAX,
        loader: true,
      })
        .then(({ close, value }) => {
          const note = val ? String(value || "").trim().slice(0, BAN_NOTE_MAX) : "";
          const body = { disabled };
          if (note) body.note = note;
          this.axios
            .put(
              `passenger/${this.$route.params.id}/change_disabled_at_value`,
              body
            )
            .then(() => this.syncBanState(disabled, note))
            .then(() => {
              window.getApp.$emit(
                "SHOW_TOAST",
                disabled
                  ? this.$t("accountState.blocked")
                  : this.$t("accountState.unblocked"),
                "green"
              );
              close();
            })
            .catch(() => {
              // revert switch on error
              this.disabledSwitch = !val;
              window.getApp.$emit(
                "SHOW_TOAST",
                this.$t("passengersPage.statusChangeFailed"),
                "red"
              );
              close();
            });
        })
        .catch(() => {
          // user cancelled dialog -> revert switch
          this.disabledSwitch = !val;
        });
    },
    // Owner item 3.1: after a ban toggle, re-read the rider so the state shown
    // is the server's (only the backend knows whether an unbanned rider is
    // active or inactive). If that read fails, fall back to the local flag.
    // Never rejects: the toggle itself already succeeded.
    syncBanState(disabled, note) {
      return this.axios
        .get(`passenger/${this.$route.params.id}`)
        .then(({ data }) => {
          const fresh = (data && data.data) || {};
          this.passenger = {
            ...this.passenger,
            blacklisted_at: fresh.blacklisted_at,
            blacklist_note: fresh.blacklist_note,
            account_state: fresh.account_state,
          };
        })
        .catch(() => {
          this.passenger = {
            ...this.passenger,
            blacklisted_at: disabled ? new Date().toISOString() : null,
            blacklist_note: disabled ? note || null : null,
            account_state: disabled ? "banned" : undefined,
          };
        })
        .then(() => {
          this.disabledSwitch = !!this.passenger.blacklisted_at;
        });
    },
    register() {


      const title = this.$t("passengersPage.acceptAccount");
      const paragraph = this.$t("passengersPage.acceptConfirm");

      this.$dialova({
        title,
        paragraph,
        loader: true,
      })
        .then(({ close }) => {
          // this.loading = true;
          this.axios
            .post(
              `passenger/${this.$route.params.id}/accept`
            )
            .then(({ data }) => {
              // The accept response carries no account_state: keep the
              // fields show() loaded and the state it reported.
              this.passenger = {
                ...this.passenger,
                ...data.data,
                account_state: this.passenger && this.passenger.account_state,
              };
              window.getApp.$emit(
                "SHOW_TOAST",
                this.$t("passengersPage.accountAccepted"),
                "green"
              );
              close();
            })
            .catch((err) => {
              console.log(err)
              window.getApp.$emit(
                "SHOW_TOAST",
                this.$t("passengersPage.acceptFailed"),
                "red"
              );
              close();
            })
            .finally(() => {
              //  this.loading = false;
            });
        })
        .catch(() => {

        });
    }
  },
  computed: {
    today() {
      return companyNow().format("YYYY-MM-DD");
    },

    disableSaveButton() {
      return Object.keys(this.changedFields()).length === 0;
    },
    genderItems() {
      return [
        { text: this.$t("passengersPage.male"), value: 1 },
        { text: this.$t("passengersPage.female"), value: 0 },
      ];
    },
    genderDisplay() {
      if (this.passenger == null || this.passenger.gender == null) return "";
      // Backend: 1 = Male, 0 = Female (same mapping as the passengers list)
      return String(this.passenger.gender) === "1"
        ? this.$t("passengersPage.male")
        : this.$t("passengersPage.female");
    },
    // Owner item 3.1: the backend's account_state (show() carries it). The ban
    // flag wins (banned > active > inactive); a payload without the field (an
    // older backend) can only tell banned from not banned.
    accountState() {
      if (!this.passenger) return null;
      if (this.passenger.blacklisted_at) return "banned";
      return isAccountState(this.passenger.account_state) ? this.passenger.account_state : null;
    },
    accountStateLabel() {
      if (!this.passenger) return "";
      // Unknown state (failed labelling, accept response, failed re-read):
      // a neutral dash, never a guessed 'Active'.
      return this.accountState
        ? this.$t("accountState." + this.accountState)
        : "-";
    },
    accountStateColor() {
      return this.accountState ? ACCOUNT_STATE_COLORS[this.accountState] : null;
    },
    tripsTitles() {
      return {
        booking_id: this.$t("passengersPage.bookingId"),
        booking_time: this.$t("passengersPage.date"),
        pickup_name: this.$t("passengersPage.pickupLocation"),
        dropdown_name: this.$t("passengersPage.dropoffLocation"),
        captain_name: this.$t("passengersPage.driverName"),
        captain_gl_code: this.$t("passengersPage.driverGlAccount"),
        status: this.$t("passengersPage.status"),
      };
    },
    formatters() {
      const orderStatuses = {
        PENDING: this.$t("passengersPage.statusPending"),
        ACCEPTED: this.$t("passengersPage.statusAccepted"),
        STARTED: this.$t("passengersPage.statusStarted"),
        ARRIVED: this.$t("passengersPage.statusArrived"),
        PICKED_UP: this.$t("passengersPage.statusPickedUp"),
        DONE: this.$t("passengersPage.statusDone"),
        PAID: this.$t("passengersPage.statusPaid"),
        CAPTAIN_CANCELLED: this.$t("passengersPage.statusCaptainCancelled"),
        PASSENGER_CANCELLED: this.$t("passengersPage.statusPassengerCancelled"),
        SYSTEM_CANCELLED: this.$t("passengersPage.statusSystemCancelled"),
        CC_CANCELLED: this.$t("passengersPage.statusCcCancelled"),
      };

      return {
        booking_time(value) {
          return formatCompanyTime(value, "DD-MM-YYYY HH:mm");
        },
        captain_gl_code(value) {
          return value === null || value === undefined || value === "" ? "-" : value;
        },
        created_at(value) {
          return formatCompanyTime(value, "DD-MM-YYYY HH:mm");
        },
        status(value) {
          return orderStatuses[value] || value || "";
        },
      };
    },
    actionsExtraMain() {
      return {};
    },
  },
};
</script>

<style lang="scss" scoped>
.body {
  background-color: #ffffff !important;
}

.docs:hover {
  cursor: pointer;
}

.star {
  color: #f3c220;
}

.image {
  border-radius: 100%;
  height: 100px;
  width: 100px;
  margin-inline-end: 17px;
  margin-top: 10px;
}

.image:hover {
  background-color: black;
  opacity: 0.5;
  border-radius: 100%;
  cursor: pointer;
}

.tab {
  color: #e21024 !important;
}

.active {
  border-style: solid;
  border-color: #e42235;
  border-width: thin;
}

.passengers-list {
  width: 100%;
  margin-inline-start: 90px;
  z-index: 7;
  max-height: 100px;
  min-height: 100px;
  float: inline-start;
  padding: 22px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    border-radius: 10px;
    background-color: #ededed;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: #788e98;
  }
}

.passenger {
  width: max-content;
  float: inline-start;
  font-size: 12pt;
  font-weight: normal !important;
  padding: 12px;
  box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.08);
  display: flex;
  align-items: center;
  gap: 12px;
  border-radius: 6px;
  cursor: pointer;

  img {
    height: 32px;
    width: 32px;
    float: inline-start;
    border-radius: 100%;
  }

  .name {
    color: #202731;
    width: max-content;
    overflow: hidden;
    min-width: 140px;
    max-width: 250px;
  }
}

.car {
  color: #7e939c;
}

.open {
  margin-bottom: 15px;
  margin-inline-start: 35px;
}

.constraints.v-label {
  font-size: xx-large !important;
}

table {
  max-width: 500px;
  width: 500px;

  tr {

    th,
    td {
      padding: 0 12px;
      text-align: start;

      span {
        padding: 16px 0;
        float: inline-start;
      }
    }

    th {
      padding-inline-start: 0;
    }

    td {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      flex-direction: row;
      gap: 14px;
      max-width: 350px;
      width: 350px;
    }
  }
}

.tab-content-wrapper {
  touch-action: pan-y !important;
  height: 100%;
  overflow-y: auto;
}

.ban-note {
  color: #8599a3;
  font-size: 12px;
  overflow-wrap: anywhere;
}
</style>
